import { useTheme } from '@mui/material/styles';

export const DegradationBannerImage = () => {
  const theme = useTheme();

  return (
    <svg
      width="128"
      height="128"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_degradation_banner)">
        <g filter="url(#filter0_d_degradation_banner)">
          <rect
            x="35.0273"
            y="-9.69482"
            width="102"
            height="108.992"
            rx="24"
            transform="rotate(14 35.0273 -9.69482)"
            fill={theme.tokens.colors.accent.bg.blue}
          />
        </g>
        <g filter="url(#filter1_d_degradation_banner)">
          <rect
            x="20.3115"
            y="3.22217"
            width="102"
            height="108.992"
            rx="24"
            transform="rotate(-2 20.3115 3.22217)"
            fill={theme.tokens.colors.accent.bg.blue}
          />
        </g>
        <g filter="url(#filter2_di_degradation_banner)">
          <rect
            x="15.5654"
            y="6.15137"
            width="116.306"
            height="112"
            rx="32"
            transform="rotate(-12 15.5654 6.15137)"
            fill={theme.tokens.colors.original.brand.quaternary}
          />
        </g>
        <g filter="url(#filter3_i_degradation_banner)">
          <circle
            cx="81.9844"
            cy="49.285"
            r="40"
            transform="rotate(-12 81.9844 49.285)"
            fill={theme.tokens.colors.bg.light.primary}
          />
        </g>
        <g filter="url(#filter4_i_degradation_banner)">
          <path
            d="M79.2101 40.5292C80.3068 40.2964 81.4229 40.8308 81.9289 41.8312L83.4597 44.8574C83.4657 44.8693 83.4766 44.8783 83.4896 44.881C84.3346 45.0593 85.155 45.3151 85.9414 45.6408C86.1905 45.7439 86.4732 45.7374 86.7122 45.6127L89.2511 44.2883C90.2647 43.7599 91.5188 43.9759 92.2896 44.8116L95.2487 48.0194C96.0195 48.8552 96.1077 50.0958 95.4632 51.0248L93.8285 53.381C93.6704 53.6089 93.6307 53.8973 93.7102 54.163C93.8111 54.4998 93.8998 54.8434 93.9741 55.1931C94.056 55.5784 94.1192 55.9635 94.1655 56.3475C94.1991 56.6255 94.3532 56.8772 94.5926 57.0225L97.0568 58.5174C98.0233 59.1041 98.4465 60.2735 98.0823 61.3505L96.684 65.4855C96.3196 66.5623 95.2617 67.2691 94.1208 67.1984L91.126 67.0123C90.8605 66.9959 90.6033 67.1026 90.4181 67.2936C89.8581 67.871 89.2447 68.4023 88.5839 68.8805C88.5758 68.8864 88.5719 68.8961 88.5714 68.9061L88.4047 72.2931C88.3494 73.4131 87.5466 74.3563 86.4498 74.5896L81.6565 75.6084C80.5597 75.8415 79.4427 75.3063 78.9366 74.3056L77.4067 71.2792C77.4041 71.274 77.3984 71.2704 77.3926 71.2692C76.5871 71.1009 75.8035 70.8626 75.0505 70.56C74.8034 70.4608 74.5245 70.469 74.2885 70.5922L71.6347 71.977C70.6211 72.5058 69.3663 72.2906 68.5954 71.4549L65.6361 68.2461C64.8654 67.4103 64.7771 66.1697 65.4216 65.2407L67.0606 62.8766C67.2201 62.6465 67.2583 62.3539 67.1762 62.0863C67.0624 61.7159 66.9641 61.3376 66.8821 60.9517C66.8075 60.6011 66.7478 60.2503 66.7026 59.9006C66.6669 59.6257 66.5134 59.3783 66.2765 59.2344L63.828 57.7481C62.8614 57.1616 62.4375 55.9923 62.8015 54.9153L64.1999 50.7802C64.5642 49.7032 65.6227 48.9953 66.7638 49.0662L69.62 49.2438C69.8888 49.2604 70.1491 49.1514 70.3346 48.9561C70.9246 48.335 71.576 47.7655 72.2806 47.2566C72.2888 47.2506 72.2936 47.2409 72.2941 47.2307L72.4617 43.8436C72.517 42.7237 73.3192 41.7815 74.4158 41.5483L79.2101 40.5292ZM79.02 51.4479C75.2319 52.2533 72.7909 55.871 73.5682 59.5285C74.3457 63.1861 78.0471 65.4981 81.8353 64.6931C85.6237 63.8878 88.0646 60.2702 87.2871 56.6125C86.5096 52.9548 82.8083 50.6427 79.02 51.4479Z"
            fill={theme.tokens.colors.accent.stroke.blue}
          />
          <path
            d="M84.122 23.2228C84.9428 22.4842 86.1577 22.3901 87.0825 22.9935C87.1919 23.0648 87.2933 23.1432 87.3866 23.2274C87.7033 23.5133 88.1412 23.6834 88.5527 23.5705C88.854 23.4879 89.1585 23.4227 89.4645 23.3748C89.8695 23.3114 90.1909 22.9994 90.3653 22.6284C90.4109 22.5315 90.4633 22.436 90.5229 22.3426C91.1379 21.3774 92.3383 20.9293 93.4247 21.2659L94.3917 21.5648C95.4778 21.9016 96.1734 22.9377 96.0779 24.0637C96.0689 24.1702 96.0531 24.2744 96.0312 24.3761C95.9417 24.7911 96.0155 25.2517 96.3168 25.5509C96.4174 25.6508 96.5157 25.754 96.6116 25.8605C96.7217 25.9827 96.827 26.1076 96.9278 26.2349C97.1943 26.5714 97.6504 26.6955 98.0771 26.6489C98.1806 26.6377 98.2861 26.6328 98.3931 26.635C99.523 26.6577 100.481 27.4583 100.703 28.5739L100.899 29.5668C101.12 30.6823 100.549 31.8294 99.5248 32.3402C99.4102 32.3973 99.2939 32.4446 99.1768 32.4825C98.7809 32.6107 98.4259 32.8966 98.3157 33.2978C98.2401 33.5726 98.1502 33.8444 98.0459 34.1121C97.8908 34.5098 98.0144 34.9633 98.2658 35.3082C98.3402 35.4102 98.4078 35.5197 98.4676 35.6364C98.9709 36.6193 98.7499 37.8184 97.9294 38.5574L96.8655 39.5153C96.0448 40.254 94.8298 40.3478 93.905 39.7446C93.7959 39.6735 93.6947 39.5955 93.6015 39.5118C93.284 39.2266 92.8455 39.057 92.4341 39.1703C92.1537 39.2475 91.8706 39.3097 91.5861 39.3568C91.1756 39.4247 90.8542 39.7476 90.6852 40.1278C90.6353 40.2399 90.5762 40.3503 90.5077 40.4579C89.8927 41.423 88.6921 41.8711 87.6058 41.5346L86.6396 41.235C85.5531 40.8983 84.8577 39.8624 84.9533 38.7362C84.9624 38.6296 84.9781 38.5253 84.9999 38.4236C85.0901 38.0039 85.0142 37.5371 84.7077 37.2366C84.592 37.1232 84.4792 37.0055 84.3693 36.8835C84.2731 36.7767 84.1804 36.6678 84.0912 36.5571C83.8248 36.2267 83.3746 36.1052 82.9527 36.1506C82.8498 36.1616 82.7451 36.1664 82.6389 36.1643C81.5089 36.1416 80.5514 35.3416 80.33 34.226L80.1324 33.2331C79.9112 32.1175 80.483 30.971 81.5072 30.4604C81.6061 30.4111 81.7063 30.369 81.8072 30.3339C82.1944 30.1994 82.5382 29.9126 82.6437 29.5165C82.7242 29.2147 82.8221 28.9163 82.9372 28.6229C83.0931 28.2257 82.9702 27.7722 82.7195 27.427C82.646 27.3258 82.5791 27.2173 82.5199 27.1017C82.0164 26.1187 82.2374 24.9197 83.0581 24.1807L84.122 23.2228ZM87.8044 28.3896C86.0927 29.931 85.9067 32.5151 87.3892 34.1617C88.8718 35.8084 91.4618 35.8941 93.1738 34.3529C94.8858 32.8114 95.0718 30.226 93.5891 28.5793C92.1064 26.9327 89.5164 26.8481 87.8044 28.3896Z"
            fill={theme.tokens.colors.accent.stroke.blue}
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_degradation_banner"
          x="9.74707"
          y="-4.60742"
          width="123.163"
          height="128.256"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.133333 0 0 0 0 0.427451 0 0 0 0 0.996078 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_degradation_banner"
          x="17.1338"
          y="0.484863"
          width="112.097"
          height="118.841"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.133333 0 0 0 0 0.427451 0 0 0 0 0.996078 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_di_degradation_banner"
          x="17.5127"
          y="-16.083"
          width="133.156"
          height="133.839"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.133333 0 0 0 0 0.427451 0 0 0 0 0.996078 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-4" dy="-4" />
          <feGaussianBlur stdDeviation="4.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.133333 0 0 0 0 0.427451 0 0 0 0 0.996078 0 0 0 0.49 0"
          />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow" />
        </filter>
        <filter
          id="filter3_i_degradation_banner"
          x="41.9766"
          y="9.27686"
          width="82.0156"
          height="82.0166"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="2" dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.133333 0 0 0 0 0.427451 0 0 0 0 0.996078 0 0 0 0.25 0"
          />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter
          id="filter4_i_degradation_banner"
          x="61.6719"
          y="21.1548"
          width="39.2744"
          height="55.5078"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-1" dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.211765 0 0 0 0.12 0"
          />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
        </filter>
        <clipPath id="clip0_degradation_banner">
          <rect width="128" height="128" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
